import Organization from "../../../Shared/Svgs/Organization";
import DashboardTitle from "../../Dashboard/DashboardTitle/DashboardTitle";

const CompanyInfoTitle = () => {
    return (
        <div className="CompanyInfoTitle">
            <DashboardTitle
                title="Company Info"
                svg={<Organization />}
            />

            <div className="verticalBar"></div>

            <img
                src="/images/dentons-logo.png"
                className="companyInfoTitleLogo"
                alt="logo"
            />
        </div>
    );
};

export default CompanyInfoTitle;
